export default __webpack_public_path__ + "c6f403f2a5f1edeff4e5642eda7bdb23.png";